export const TEMPLATE_DOMAIN_PREFIX = 'template.';

export function stripWwwPrefix(domain: string): string {
  return (domain || '').trim().replace(/^www\./i, '');
}

export function isTemplatePrefixedDomain(domain: string): boolean {
  return stripWwwPrefix(domain).toLowerCase().startsWith(TEMPLATE_DOMAIN_PREFIX);
}

/** Prefix a live host with template. so templates are not matched as real sites. */
export function toTemplateDomain(domain: string): string {
  const stripped = stripWwwPrefix(domain);
  if (!stripped) return '';
  if (stripped.toLowerCase().startsWith(TEMPLATE_DOMAIN_PREFIX)) {
    return `${TEMPLATE_DOMAIN_PREFIX}${stripped.slice(TEMPLATE_DOMAIN_PREFIX.length)}`;
  }
  return `${TEMPLATE_DOMAIN_PREFIX}${stripped}`;
}

/** Strip template. (and www.) so a locale child can use the live host. */
export function fromTemplateDomain(domain: string): string {
  const stripped = stripWwwPrefix(domain);
  if (!stripped) return '';
  if (stripped.toLowerCase().startsWith(TEMPLATE_DOMAIN_PREFIX)) {
    return stripped.slice(TEMPLATE_DOMAIN_PREFIX.length);
  }
  return stripped;
}
